export enum ProcedureRequestStatus {
    /// <summary>
    /// User create the request and no actions taked
    /// </summary>
    Created,
    /// <summary>
    /// Has at list 1 action (delegate is action)
    /// </summary>
    InProgress,
    Rejected,
    Approved,
    HasCertificate,
    CertificateRejected,
    CertificateApproved
}